import React, { createContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';
import { getSession, getImpersonation } from '../utils/session';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const bootstrapSession = useCallback(async () => {
    try {
      const res = await api.get('/api/v1/users/session');
      const u = res.data?.data?.user;
      setUser(u || null);
      return !!u;
    } catch {
      setUser(null);
      return false;
    }
  }, []);

  const fetchUser = useCallback(() => {
    const { id } = getSession();
    if (!id && !getImpersonation()) return Promise.resolve(false);
    return bootstrapSession();
  }, [bootstrapSession]);

  useEffect(() => {
    const handleTenantChanged = () => {
      const { id } = getSession();
      if (!id && !getImpersonation()) {
        setUser(null);
        return;
      }
      bootstrapSession();
    };

    window.addEventListener('eclipse:tenant-changed', handleTenantChanged);
    return () => window.removeEventListener('eclipse:tenant-changed', handleTenantChanged);
  }, [bootstrapSession]);

  return (
    <UserContext.Provider value={{ user, setUser, fetchUser, bootstrapSession }}>
      {children}
    </UserContext.Provider>
  );
};
